import { connect } from 'react-redux'

import AddSerialNumber from '../../../components/ShipmentAction/AddSerialNumber'
import { updateFieldOrder } from '../../../redux/order/actions'
import {
  getErrorActionCourse,
  getIsLoadingActionOrder,
} from '../../../redux/order/selectors'

const mapStateToProps = (state) => ({
  isLoadingActionOrder: getIsLoadingActionOrder(state),
  errorActionCourse: getErrorActionCourse(state),
})
const mapDisptachToProps = (dispatch) => ({
  updateSerialNumber: (codeCourse, serialNumber) => {
    dispatch(updateFieldOrder(codeCourse, serialNumber))
  },
})

export default connect(mapStateToProps, mapDisptachToProps)(AddSerialNumber)
